// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.vectorizer=NEXT_PUBLIC_RPC_VECTORIZER_URL,service.creativefabrica.social=NEXT_PUBLIC_RPC_SOCIAL_URL,service.creativefabrica.uploads=NEXT_PUBLIC_RPC_UPLOADS_URL,service.creativefabrica.studio=NEXT_PUBLIC_RPC_STUDIO_URL,service.creativefabrica.content=NEXT_PUBLIC_RPC_CONTENT_URL,include.creativefabrica.vectorizer.v2.VectorizerService.List=infiniteQuery,include.creativefabrica.social.v2.SocialService.GetUserFeaturedImages=query,include.creativefabrica.social.v2.SocialService.ListImageLibrary=query,include.creativefabrica.social.v2.SocialService.SelectFeaturedImages=mutation,include.creativefabrica.social.v2.SocialService.CreateSignedUrl=mutation,include.creativefabrica.social.v2.SocialService.PostProductProject=mutation,include.creativefabrica.social.v2.SocialService.ListAssets=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMachines=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMaterials=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListThemes=infiniteQuery,include.creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl=mutation,include.creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload=mutation,include.creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload=mutation,include.creativefabrica.studio.v2.StudioService.GetUserBanStatus=query,include.creativefabrica.content.v2.MarketplaceService.GetHomepageProductRecommendations=query"
// @generated from file creativefabrica/studio/v2/service.proto (package creativefabrica.studio.v2, syntax proto3)
/* eslint-disable */

import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient } from "@connectrpc/connect";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { GetUserBanStatusResponse, GetUserBanStatusRequestSchema, StudioService } from "./service_pb";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the StudioService service
 * Service: creativefabrica.studio.v2.StudioService
 */

invariant(process.env.NEXT_PUBLIC_RPC_STUDIO_URL, 'NEXT_PUBLIC_RPC_STUDIO_URL env var is not set within gen/service/creativefabrica/creativefabrica/studio/v2/service_pb.ts. Please make sure the env var is available to your project/script/app.')

const StudioServiceTransport = createConnectTransport({
  baseUrl: process.env.NEXT_PUBLIC_RPC_STUDIO_URL,
  useBinaryFormat: false,
  interceptors,
})

const StudioServiceClient = createClient(
  StudioService,
  StudioServiceTransport,
)

/**
 * Unique identifier for the GetUserBanStatus query
 */
export const GetUserBanStatusQueryRootKey = 'StudioService.GetUserBanStatus' as const;

/**
 * Return type for the GetUserBanStatus query
 */
type GetUserBanStatusQueryResult = GetUserBanStatusResponse;

/**
 * Generates a unique query key for the GetUserBanStatus query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetUserBanStatusQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getUserBanStatusQueryKey = /*@__PURE__*/ function getUserBanStatusQueryKey(variables?: MessageInitShape<typeof GetUserBanStatusRequestSchema>): QueryKey<MessageInitShape<typeof GetUserBanStatusRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetUserBanStatusRequestSchema>> = [GetUserBanStatusQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.studio.v2.StudioService.GetUserBanStatus
 */
/**
 * Function to execute the GetUserBanStatus RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getUserBanStatusFn(variables: MessageInitShape<typeof GetUserBanStatusRequestSchema>, meta?: Record<string, unknown>): Promise<GetUserBanStatusResponse> {
  return StudioServiceClient.getUserBanStatus(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetUserBanStatus query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getUserBanStatusQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetUserBanStatusQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getUserBanStatusQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetUserBanStatusRequestSchema>): QueryOptions<GetUserBanStatusQueryResult, MessageInitShape<typeof GetUserBanStatusRequestSchema>> {
  return {
    queryKey: getUserBanStatusQueryKey(variables),
    queryFn: async (context) => getUserBanStatusFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.studio.v2.StudioService.GetUserBanStatus
 */
export function useGetUserBanStatusQuery<D = GetUserBanStatusQueryResult, E = Error>(variables: MessageInitShape<typeof GetUserBanStatusRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetUserBanStatusQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetUserBanStatusRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetUserBanStatusQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetUserBanStatusRequestSchema>>
  >({
    ...options,
    ...getUserBanStatusQueryOptions(variables),
  });
}


